function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

window.productsViewedUpdate = function() {
  let recently_viewed = [];
  const cookie_value = localStorage.getItem('shopify_recently_viewed');
  if (cookie_value) {
    recently_viewed = cookie_value.split(',');
    const cards_viewed_tags = document.querySelectorAll('div[data-recently-viewed]');

    cards_viewed_tags.forEach((tag) => {
      if (recently_viewed.includes(tag.getAttribute('data-prod-handle'))) {
        tag.style.display = '';
      }
    });
  }
};

window.addEventListener('load', function () {
  window.productsViewedUpdate();
});


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {

    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    const sizeGuideLink = this.querySelector('.size-guide-link');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });

    //open size guide modal
    if (sizeGuideLink !== null) {
      sizeGuideLink.addEventListener('click', () => {
        const sizeGuideModal = document.querySelector('#size-guide-overlay');
        if (sizeGuideModal !== null) {
          sizeGuideModal.classList.add('overlay-open');
          }
      })
    }

  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateButtons();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateButtons() {
    if (!this.currentVariant) return;

    const optionTwo = this.querySelectorAll('.product-form__input-grid input[type="radio"]');
    const colourItems = this.variantData;
    let radioButtonArray = Array.from(optionTwo);
    document.getElementById('option-1').innerHTML = this.currentVariant.option1;

    for(let radio in radioButtonArray) {
      const currentRadio = radioButtonArray[radio]
      let optionTwoValue = currentRadio.value;
      // Place in SPAN replace for Size
      const sizeItems = colourItems.filter(item => item.option1.indexOf(optionTwoValue) !== -1);
      if(sizeItems[0].available) {
        currentRadio.classList.remove('out-of-stock')
      } else {
        currentRadio.classList.add('out-of-stock')
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    // const productForm = section.querySelector('product-form');
    // if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        console.log(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const additionalBisButton = document.querySelector('.klaviyo-bis-trigger--additional');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (additionalBisButton && text) additionalBisButton.classList.add('visible');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (additionalBisButton) additionalBisButton.classList.remove('visible');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);


class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.accordion__content');
    this.insetclose = el.querySelector('inset-close');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));

    if (this.insetclose) {
      this.insetclose.addEventListener('click', (e) => this.onClick(e));
    }
  }

  onClick(e) {
    e.preventDefault();
    if (this.isClosing || !this.el.open) {
      if (this.el.classList.contains('nested-accordion')) {
        this.closeAll(true);
      } else {
        this.closeAll(false);
      }
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 200,
      easing: 'ease-in-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) {
      this.animation.cancel();
    }
    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 200,
      easing: 'ease-in-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  closeAll(subAccordions) {
    let allAccordions;
    if (subAccordions) {
      allAccordions = document.querySelectorAll('details.nested-accordion');
    } else {
      allAccordions = document.querySelectorAll('details');
    }
    allAccordions.forEach(
      (accordionEl) => {
        accordionEl.removeAttribute('open');
      }
    );
  }
}

document.querySelectorAll('details.with-sliding').forEach((el) => {
  new Accordion(el);
});


class hideNotification extends HTMLElement {
  constructor() {
    super();
    const closeBtn = this.querySelector('.notification__close');

    if (closeBtn != null) {
      closeBtn.addEventListener('click', this.hideNotification.bind(this));
    }
  }

  hideNotification(e) {
    e.preventDefault();
    this.classList.add('hidden');
  }
}
customElements.define('notification-msg', hideNotification);


class formValidator extends HTMLElement {
  constructor() {
    super();
    const inputs = this.querySelectorAll('input, select');
    const textareas = this.querySelectorAll('textarea');

    inputs.forEach(
      (input) => {
        // if (input.getAttribute('data-preset') !== null) {
        //   this.presetRequest(input, input.getAttribute('data-preset'));
        // }
        if (input.type !== 'hidden' && input.value.length > 0 && input.value !== 'disabled') {
          input.parentElement.classList.add('input-filled');
        }
      }
    );

    textareas.forEach(
      (textarea) => {
        if (textarea.type !== 'hidden' && textarea.value.length > 0) {
          textarea.parentElement.classList.add('input-filled');
        }
      }
    );

    this.addEventListener('input', this.onChange.bind(this));
  }

  onChange(event) {
    event.preventDefault();
    if (event.target.value.length > 0) {
      event.target.parentElement.classList.add('input-filled');
      event.target.parentElement.classList.remove('invalid');
    } else {
      event.target.parentElement.classList.remove('input-filled');
      if (event.target.parentElement.classList.contains('form-control--required')) {
        event.target.parentElement.classList.add('invalid');
      }
    }
  }

  // presetRequest(presetInput, presetReq) {
  //   switch (presetReq) {
  //     case 'last-product':
  //       const urlParts = document.referrer.split('/');
  //       const lastPage = urlParts[urlParts.length - 1].split('?');
  //       if (urlParts[urlParts.length - 2] == "products") {
  //         const lastProduct = lastPage[0];
  //         const lastVariant = lastPage[1];
  //         fetch(`/products/${lastProduct}.json`)
  //         .then((response) => response.json())
  //         .then((responseText) => {
  //           if (lastVariant) {
  //             const variantData = lastVariant.split('=');
  //             const variantID = variantData[variantData.length - 1];
  //             let currentVariant;
  //             for (currentVariant = 0; currentVariant < responseText.product.variants.length; currentVariant++) {
  //               if (variantID == responseText.product.variants[currentVariant].id) {
  //                 presetInput.value = responseText.product.variants[currentVariant].sku;
  //                 presetInput.nextElementSibling.classList.add('input-filled');
  //               };
  //             }
  //           } else {
  //             presetInput.value = responseText.product.variants[0].sku;
  //             presetInput.nextElementSibling.classList.add('input-filled');
  //           }
  //         });
  //       }
  //       break;

  //     case 'user-country':
  //       this.fetchUserJSON()
  //       .then(userData => {
  //         if (userData) {
  //           let userCountry = userData.country_name;
  //           userCountry = userCountry.toLowerCase().replace(/\W+/g, "-");
  //           presetInput.value = userCountry;
  //         }
  //       });
  //       break;

  //     case 'user-dialling':
  //       this.fetchUserJSON()
  //       .then(userData => {
  //         if (userData) {
  //           const userDialling = this.querySelector('option[data-countrycode="' + userData.country.handle + '"]').value;
  //           presetInput.value = userDialling;
  //         }
  //       });
  //       break;

  //     case 'user-lang':
  //       const browserLang = navigator.language.substring(0, 2);
  //       if (browserLang == 'en') {
  //         presetInput.value = 'english';
  //       } else if (browserLang == 'fr') {
  //         presetInput.value = 'francais';
  //       } else if (browserLang == 'zh') {
  //         presetInput.value = '中国人';
  //       }
  //       break;
  //   }
  // }

  // async fetchUserJSON() {
  //   let response = await fetch(`/browsing_context_suggestions.json`);
  //   let data = await response.json()
  //   return data.detected_values;
  // }
}
customElements.define('form-container', formValidator);



class secondaryHoverImage extends HTMLElement {
  constructor() {
    super();
    this.images = this.querySelectorAll('img');
    this.atcForm = this.closest('.product-card').querySelector('.product-add-form');
    this.cardAdditionalInfo = this.closest('.product-card').querySelector('.card-additional-info');
    this.isFeatureBlock = this.closest('.product-card').classList.contains('feature-block') ? true : false;
    this.addEventListener('mouseover', (e) => this.onEnter(e));
    this.addEventListener('mouseleave', (e) => this.onLeave(e));
    if (this.atcForm) {
      this.atcForm.addEventListener('mouseover', (e) => this.onEnter(e));
      this.atcForm.addEventListener('mouseleave', (e) => this.onLeave(e));
    }

    if(this.cardAdditionalInfo) {
      this.cardAdditionalInfo.addEventListener('mouseover', (e) => this.onEnter(e));
      this.cardAdditionalInfo.addEventListener('mouseleave', (e) => this.onLeave(e));
    }
  }

  onEnter(e) {
    if(this.isFeatureBlock) return;
    if (this.images.length !== 2) return;
    this.images[0].classList.remove('show');
    this.images[1].classList.add('show');
  }

  onLeave(e) {
    if(this.isFeatureBlock) return;
    if (this.images.length !== 2) return;
    this.images[0].classList.add('show');
    this.images[1].classList.remove('show');
  }
}
customElements.define('hover-image-block', secondaryHoverImage);

class variantSwitchControl extends HTMLElement {
  constructor() {
    super();
    const mainImg = this.querySelector('img')
    const toggles = this.querySelectorAll('[data-variant-switch-toggle]')

    this.mainImgCheck(mainImg);

    toggles.forEach(
      (button) => {
        button.addEventListener('click', this.toggleVariant.bind(this))
        if (button.classList.contains('selected')) {
          this.switchVariant(button.getAttribute('data-product-option-id'));
        }
      }
    );
  }

  mainImgCheck(mainImg) {
    let imgCheck = mainImg.naturalHeight !== 0;
    if (imgCheck) {
      this.classList.remove('loading-in');
    } else {
      this.mainImgFail(mainImg);
    }
  }

  mainImgFail(mainImg) {
    setTimeout(() => {
      this.mainImgCheck(mainImg);
    }, 100);
  }

  toggleVariant(event) {
    event.preventDefault();
    let eventNode;
    if (event.target.getAttribute('data-product-option-id') == null) {
      eventNode = event.target.parentNode;
    } else {
      eventNode = event.target;
    }

    if (eventNode.classList.contains('selected')) return;
    const toggles = this.querySelectorAll('[data-variant-switch-toggle]');
    const variantID = eventNode.getAttribute('data-product-option-id');

    toggles.forEach(
      (option) => option.classList.remove('selected')
    );
    eventNode.classList.add('selected');
    this.switchVariant(variantID);
  }

  switchVariant(variantID) {
    const blocks = this.querySelectorAll('[data-variant-switch-block]');
    const items = this.querySelectorAll('[data-variant-switch-item]');

    items.forEach(
      (option) => {
        if (option.getAttribute('data-variant-switch-ids').length == 0) return;
        if (option.getAttribute('data-variant-switch-ids') == variantID) {
          option.classList.add('show');
         } else {
           option.classList.remove('show');
         }
      }
    );
  }
}
customElements.define('variant-switch-container', variantSwitchControl);


class CartUpsells extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.update();
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);

  }

  update() {
    const productId = document.querySelector('#CartItem-1').dataset.productId;
    const url = this.dataset.url.split('product_id=')[0];
    const fetchUrl = url + 'product_id=' + productId;

    return fetch(fetchUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-upsells');
        if (recommendations && recommendations.innerHTML.trim().length) {
          if (this.dataset.hideShopifyRecommendations) {
            const hasCustomCrossellItems = recommendations.querySelectorAll('.product-card--custom-crossell') ? true : false;
            if (hasCustomCrossellItems) {
              recommendations.querySelectorAll('.product-card--shopify-recommended').forEach(
                (card) => card.remove()
              );
            }
          }
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .then( () => {
        let swiper = false;
        const minicartRecommendationsStyle1Slider = this.querySelector('.minicart-upsell-slider--style-1');
        const minicartRecommendationsStyle2Slider = this.querySelector('.minicart-upsell-slider--style-2');

        if (minicartRecommendationsStyle1Slider) {
          swiper = new Swiper(minicartRecommendationsStyle1Slider, {
            slidesPerView: 2, // 4
            spaceBetween: 4,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          })
        }

        if (minicartRecommendationsStyle2Slider) {
          swiper = new Swiper(minicartRecommendationsStyle2Slider, {
            slidesPerView: 3.1, // Default
            spaceBetween: 4,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            breakpoints: {
              0: {
                slidesPerView: 1.5, // Based on 70%
              },
              360: {
                slidesPerView: 2.2, // Based on 46%
              },
              490: {
                slidesPerView: 2.4, // Based on 42%
              },
              590: {
                slidesPerView: 3, // Based on 32.5%
              },
              750: {
                slidesPerView: 2.2, // Based on 46%
              },
              930: {
                slidesPerView: 2.2, // Based on 46%
              },
              1050: {
                slidesPerView: 2.6, // Based on 38%
              },
              1400: {
                slidesPerView: 3.1, // Based on 29%
              },
              1530: {
                slidesPerView: 4, // Based on 25%
              },
            },
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('cart-upsells', CartUpsells);

class buyTheLook extends HTMLElement {
  constructor() {
    super();
    const variants = this.querySelectorAll('.atc-group button');
    this.cartItems = document.querySelector('cart-items');
    this.miniCart = document.getElementById('mini-cart');
    const atc = this.querySelector('#buy-the-look-atc');

    atc.addEventListener('click', (e) => this.submitForm(e));

    variants.forEach(
      (button) => {
        button.addEventListener('click', function() {
          variants.forEach(
            (button) => {
              button.classList.remove('selected');
            }
          )
          button.classList.add('selected');
          const value = button.innerHTML;
          const container = button.closest('buy-the-look-container')
          const span = container.querySelector('[data-size-span]');
          span.innerHTML = value;
        })
      }
    );
  }

  removeClasses() {
    variants.forEach(
      (button) => {
        button.classList.remove('selected');
      }
    )
  }

  submitForm(e) {
    let variantID;
    const variants = this.querySelectorAll('.atc-group button');
    variants.forEach(
      (button) => {
        if(button.classList.contains('selected')) {
          variantID = button.getAttribute('variant-ids');
        }
      }
    );


    const itemsArr = [{
      quantity: 1,
      id: variantID,
    }];

    let body = {
      items: itemsArr
    };

    if (this.cartItems) {
      body.sections = this.cartItems.getSectionsToRender().map(section => section.id);
      body.sections_url = window.location.pathname;
    }

    body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {

        if (!parsedState.items && parsedState.message) {
          if (parsedState.status == 422) {
            document.querySelector('.mini-cart-add-error').classList.remove('hidden');
            this.miniCart?.open();
          }
          return this.dispatchEvent(
            new CustomEvent(
              'fostr-quick-buy-done',
              { bubbles: true, detail: { status: 'error', info: parsedState } }
            )
          );
        }

        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'success' } }
          )
        );

        let fadeClass = '';
        if (this.fade) {
          varIdsArr.forEach((id, index) => {
            if (fadeClass === '') {
              fadeClass += `.variant-id-${id}`;
            } else {
              fadeClass += `, .variant-id-${id}`;
            }
          });
        }
        this.cartItems?.renderContents(parsedState, fadeClass);
        return this.cartItems?.checkGifts();
      })
      .catch(error => {
        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'error', error: error } }
          )
        );
        console.error(error);
      })
  }

  toggleVariant(event) {
    event.preventDefault();
    let eventNode;
    if (event.target.getAttribute('data-product-option-id') == null) {
      eventNode = event.target.parentNode;
    } else {
      eventNode = event.target;
    }

    if (eventNode.classList.contains('selected')) return;
    const toggles = this.querySelectorAll('[data-variant-switch-toggle]');
    const variantID = eventNode.getAttribute('data-product-option-id');

    toggles.forEach(
      (option) => option.classList.remove('selected')
    );
    eventNode.classList.add('selected');
    this.querySelector('[data-color-span]').innerHTML = variantID;
    this.switchVariant(variantID);
  }

  switchVariant(variantID) {
    const blocks = this.querySelectorAll('[data-variant-switch-block]');
    const items = this.querySelectorAll('[data-variant-switch-item]');

    items.forEach(
      (option) => {
        if (option.getAttribute('data-variant-switch-ids').length == 0) return;
        if (option.getAttribute('data-variant-switch-ids') == variantID) {
          option.classList.add('show');
         } else {
           option.classList.remove('show');
         }
      }
    );
  }
}
customElements.define('buy-the-look-container', buyTheLook);


class mobileSizeTrigger extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector('.mobile-add-to-bag');
    this.closeButton = this.closest('.product-card').querySelector('.mobile-title-with-close a');
    this.productForm = this.closest('.product-card').querySelector('.product-add-form');
    this.quickBuyContainer = document.getElementById('quick-buy-container');
    this.quickBuyContent = document.getElementById('quick-buy-content');
    this.closeIcon = document.querySelector('#quickbuy-close');

    this.addEventListener('click', (e) => this.openSizes());
  }

  openSizes() {
    const prodHandle = this.getAttribute('data-product-handle');
    const insertLocation = this.closest('.product-card').querySelector('.populate-mobile-quickbuy-modal');
    this.closeIcon.style.display = 'none';

    document.querySelector("#mini-cart").close();

    if (insertLocation) {
      fetch(`/products/${prodHandle}?section_id=hera-mobile-quickbuy`)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section mobile-quickbuy-modal');
        this.closest('.product-card').querySelector('.populate-mobile-quickbuy-modal').replaceWith(sectionInnerHTML);
        let productFormClone = this.productForm.cloneNode(true);
        this.quickBuyContent.appendChild(productFormClone);

        document.body.classList.add('is-offcanvas-open', 'quickbuy-open');
        setTimeout(() => {
          this.quickBuyContainer.style.height = `${this.quickBuyContent.querySelector('.product-add-form').offsetHeight}px`;
          setTimeout(() => {
            this.closeIcon.style.display = 'block';
          }, 300);
        }, 1000);
      });
    } else {
      let productFormClone = this.productForm.cloneNode(true);
      this.quickBuyContent.appendChild(productFormClone);
      document.body.classList.add('is-offcanvas-open', 'quickbuy-open');
      setTimeout(() => {
        this.quickBuyContainer.style.height = `${this.quickBuyContent.querySelector('.product-add-form').offsetHeight}px`;
        setTimeout(() => {
          this.closeIcon.style.display = 'block';
        }, 300);
      }, 1000);
    }
  }

  closeSizes(e) {
    e?.preventDefault();
    document.body.classList.remove('is-offcanvas-open', 'quickbuy-open');
    this.quickBuyContent.innerHTML = '';
  }
}
customElements.define('mobile-variant-selector', mobileSizeTrigger);


class sizeGuide extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector('.size-guide-button');
    this.closeButton = document.getElementsByClassName('size-guide-close')[0];
    this.overlay = document.getElementById('size-guide-overlay');
    this.overlay.addEventListener('click', (e) => this.overlayClickClose(e));
    this.openButton.addEventListener('click', (e) => this.openSizes(e));
    this.closeButton.addEventListener('click', (e) => this.closeSizes(e));
  }

  openSizes() {
    if (this.openButton.classList.contains('embed-guide')) {
      this.overlay.querySelector('.size-guide-overlay-inner').innerHTML = this.querySelector('.size-guide-overlay-inner').innerHTML;
      this.overlay.getElementsByClassName('size-guide-close')[0].addEventListener('click', (e) => this.closeSizes(e));
    }
    this.overlay.classList.add('overlay-open');
  }

  overlayClickClose(e) {
    if (e.target.id == 'size-guide-overlay') {
      this.closeSizes();
    }
  }

  closeSizes() {
    this.overlay.classList.remove('overlay-open');
  }
}
customElements.define('size-guide', sizeGuide);

class verifiedQuality extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector('.verified-quality-button');
    this.closeButton = document.getElementsByClassName('verified-quality-modal-close')[0];
    this.overlay = document.getElementById('verified-quality-modal-overlay');
    this.overlay.addEventListener('click', (e) => this.overlayClickClose(e));
    this.openButton.addEventListener('click', (e) => this.openSizes(e));
    this.closeButton.addEventListener('click', (e) => this.closeSizes(e));
  }

  openSizes() {
    if (this.openButton.classList.contains('embed-guide')) {
      this.overlay.querySelector('.verified-quality-modal-overlay-inner').innerHTML = this.querySelector('.verified-quality-modal-overlay-inner').innerHTML;
      this.overlay.getElementsByClassName('verified-quality-modal-close')[0].addEventListener('click', (e) => this.closeSizes(e));
    }
    this.overlay.classList.add('overlay-open');
  }

  overlayClickClose(e) {
    if (e.target.id == 'verified-quality-modal-overlay') {
      this.closeSizes();
    }
  }

  closeSizes() {
    this.overlay.classList.remove('overlay-open');
  }
}
customElements.define('verified-quality', verifiedQuality);

class atcTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-quick-buy-btn]');
    this.cartItems = document.querySelector('cart-items');
    this.miniCart = document.getElementById('mini-cart');

    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();

    this.variantIds = this.getAttribute('variant-ids');
    this.properties = this.getAttribute('line-item-props');
    this.fade = !!this.getAttribute('fade');

    if (!this.variantIds) {
      return;
    }

    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');

    if (this.fade) {
      this.classList.add('animate__animated', 'animate__fadeOut', 'animate__faster');
    }

    const quantityEl = this.querySelector('input[name="quantity"]');
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1;

    let properties;
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties);
      } catch (err) {
        console.error(err);
      }
    }

    let itemsArr = [];
    const varIdsArr = this.variantIds.split(',');
    varIdsArr.forEach(varId => {
      itemsArr.push({
        id: varId,
        quantity: quantity,
        properties: properties
      });
    });

    let body = {
      items: itemsArr
    };

    if (this.cartItems) {
      body.sections = this.cartItems.getSectionsToRender().map(section => section.id);
      body.sections_url = window.location.pathname;
    }

    body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {

        if (!parsedState.items && parsedState.message) {
          if (parsedState.status == 422) {
            document.querySelector('.mini-cart-add-error').classList.remove('hidden');
            this.miniCart?.open();
          }
          return this.dispatchEvent(
            new CustomEvent(
              'fostr-quick-buy-done',
              { bubbles: true, detail: { status: 'error', info: parsedState } }
            )
          );
        }

        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'success' } }
          )
        );

        let fadeClass = '';
        if (this.fade) {
          varIdsArr.forEach((id, index) => {
            if (fadeClass === '') {
              fadeClass += `.variant-id-${id}`;
            } else {
              fadeClass += `, .variant-id-${id}`;
            }
          });
        }
        this.cartItems?.renderContents(parsedState, fadeClass);
        return this.cartItems?.checkGifts();
      })
      .catch(error => {
        this.dispatchEvent(
          new CustomEvent(
            'fostr-quick-buy-done',
            { bubbles: true, detail: { status: 'error', error: error } }
          )
        );
        console.error(error);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
        document.getElementById('quick-buy-content').innerHTML = '';
        if (window.innerWidth <= 750) {
          document.body.classList.remove('quickbuy-open', 'is-offcanvas-open');
        }
        let cardWrapper = document.getElementsByClassName("card-wrapper");
        for (let i = 0; i < cardWrapper.length; i++) {
          cardWrapper[i].classList.remove('active');
          document.getElementById(`mini-cart`).classList.remove('upsell-open');
        }
      });
  }
}

customElements.define('add-to-cart-button', atcTrigger);

class minicartUpsellTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-quick-buy-btn]');
    this.variantID = this.getAttribute('variant-ids');

    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();
    document.getElementById(`minicart-upsell-${this.variantID}`).classList.add('active');
    document.getElementById(`mini-cart`).classList.add('upsell-open');
    document.getElementById('mini-cart').scrollTop = 0;
  }
}

customElements.define('minicart-upsell-button', minicartUpsellTrigger);

// ----- Updates the mini cart when an element adds/updates/removes at the cart object API but if the element has the following attr and classes
class minicartUpsellDrawer extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-quick-buy-btn]');
    this.variantID = this.getAttribute('variant-ids');
    this.closeButton = this.querySelector('.minicart-upsell-drawer-close');
    const atcButton = this.querySelector('add-to-cart-button');
    const variantButtons = this.querySelectorAll('.variant-grid button');

    variantButtons.forEach(
      (variantButton) => {
        variantButton.addEventListener('click', function() {
          variantButtons.forEach(
            (variantButton) => {
              variantButton.classList.remove('selected');
            }
          );
          variantButton.classList.add('selected');
          atcButton.setAttribute('variant-ids', variantButton.getAttribute('variant-ids'));
        });
      }
    );

    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onClickHandler.bind(this));
    this.closeButton.addEventListener('click', this.closeDrawer.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();
    document.getElementById(`minicart-upsell-${this.variantID}`).classList.add('active');
  }

  closeDrawer(event) {
    event.preventDefault();
    document.getElementById(`minicart-upsell-${this.variantID}`).classList.remove('active');
    document.getElementById(`mini-cart`).classList.remove('upsell-open');
  }
}
// -------- Updates the mini cart END

customElements.define('minicart-upsell-drawer', minicartUpsellDrawer);
class mobileGridView extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('a');
    this.productGrid = document.querySelector('#product-grid');

    this.toggleButton.addEventListener('click', (e) => this.toggleView(e));
  }

  toggleView(e) {
    e.preventDefault();
    if (this.productGrid.classList.contains('list-view')) {
      this.productGrid.classList.remove('list-view');
      this.toggleButton.classList.remove('list-view');
    } else {
      this.productGrid.classList.add('list-view');
      this.toggleButton.classList.add('list-view');
    }
  }
}
customElements.define('toggle-mobile-grid', mobileGridView);


class toggleFilterMenu extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('button');
    this.toggleButton.addEventListener('click', (e) => this.toggleView(e));
    document.querySelector('.close-filter-menu').addEventListener('click', (e) => this.closeFilter(e));
  }

  toggleView(e) {
    const filterBar = document.querySelector('#main-collection-filters');
    const sortBar = document.querySelector('#desktop-sort');

    e.preventDefault();
    if (sortBar.classList.contains('open')) {
      document.querySelector('toggle-sort-menu').classList.remove('open');
      sortBar.classList.remove('open');
    }

    if (filterBar.classList.contains('open')) {
      document.body.classList.remove('overlay-open-mobile', 'filter-open');
      this.classList.remove('open');
      filterBar.classList.remove('open');
    } else {
      document.body.classList.add('overlay-open-mobile', 'filter-open');
      this.classList.add('open');
      filterBar.classList.add('open');
    }
  }

  closeFilter(e) {
    const filterBar = document.querySelector('#main-collection-filters');

    e.preventDefault();
    document.body.classList.remove('overlay-open-mobile', 'filter-open');
    this.classList.remove('open');
    filterBar.classList.remove('open');

    mobileOnFiltersApplyReload();
  }
}
customElements.define('toggle-filter-menu', toggleFilterMenu);

// ------ iOS 16 safari hotfix for pagination breaking on filter apply
function mobileOnFiltersApplyReload(){
  let windowScreenWidth = window.screen.width;

  // detect iOS version
  function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      let v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
  }

  ver = iOSversion();

  if (ver[0] >= 16) {
    if(windowScreenWidth <= 990) {
      location.reload();
    }
  }
  // if (ver[0] <= 15) {
  //   console.log('This is running iOS 15 or lower.');
  // }
  // detect iOS version END
}
// ------ iOS 16 safari hotfix for pagination breaking on filter apply END

class toggleSortMenu extends HTMLElement {
  constructor() {
    super();
    this.toggleButton = this.querySelector('button');
    this.toggleButton.addEventListener('click', (e) => this.toggleView(e));
  }

  toggleView(e) {
    const sortBar = document.querySelector('#desktop-sort');
    const filterBar = document.querySelector('#main-collection-filters');

    e.preventDefault();
    if (filterBar.classList.contains('open')) {
      document.querySelector('toggle-filter-menu').classList.remove('open');
      filterBar.classList.remove('open');
    }

    if (sortBar.classList.contains('open')) {
      this.classList.remove('open');
      sortBar.classList.remove('open');
    } else {
      this.classList.add('open');
      sortBar.classList.add('open');
    }
  }
}
customElements.define('toggle-sort-menu', toggleSortMenu);



let cloneClose = document.getElementById('quickbuy-close');
cloneClose.addEventListener('click', function(e){
  e.preventDefault();
  document.body.classList.remove('quickbuy-open', 'is-offcanvas-open');
  setTimeout(() => {
    document.getElementById('quick-buy-content').innerHTML = '';
  }, 450);
});


class newsletterSignup extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', (e) => {
      e.preventDefault();
      var _klOnsite = window._klOnsite || [];
      _klOnsite.push(['openForm', 'RTwVz9']);
    });
  }
}
customElements.define('newsletter-signup-trigger', newsletterSignup);

// Quick Buy iOS Chrome Fix
if(/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent)){
    document.head.insertAdjacentHTML("beforeend", `<style>#quick-buy-container .product-add-form{padding-bottom:20px}</style>`);
}


// ---------------- Salvation Donation Functions in Mini Cart -------------------
addDonationProduct();

function addDonationProduct(){


  let donationButton = document.getElementById("donationTriggerButton");

  if (!donationButton){
    return;
  }

  let productID = donationButton.getAttribute("donation-prod-id");

  if (!productID){
    return;
  }

  let addData = {
    'id':productID,
    'quantity':1
  };

  if (!addData){
    return;
  }

  // call fetch add to cart on click
  donationButton.addEventListener('click', function(){
    fetchAddToCart();
    const donationProductContainer = document.querySelector('#salv-wrapper');
    donationProductContainer.style.display = "none";

  });

  // fetch add to cart
  function fetchAddToCart(){
    fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then(function(response) {
      //return response.json();
    }).then(function(json) {
      //console.log(json);
    }).catch(function(err) {
      //console.error(err);
    });
  }

}

// ---------------- Salvation Donation Functions in Main Cart Page
addDonationProductMainCart();

function addDonationProductMainCart(){
  let donationButtonMain = document.getElementById("donationTriggerButtonMainCart");

  if (!donationButtonMain){
    return;
  }

  let productIDMain = donationButtonMain.getAttribute("donation-prod-id");

  if (!productIDMain){
    return;
  }

  let addData = {
    'id':productIDMain,
    'quantity':1
  };

  if (!addData){
    return;
  }

  // call fetch add to cart on click
  donationButtonMain.addEventListener('click', function(){
    fetchAddToCart();
  });

  // fetch add to cart
  function fetchAddToCart(){
    fetch('/cart/add.js', {
      body: JSON.stringify(addData),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then(function(response) {
      //return response.json();
    }).then(function(json) {
      //console.log(json);

      let cartData = json;
      let mainCartItems = document.getElementsByClassName("cart-item");
      let quantityInput = document.getElementsByClassName("quantity-displayed-cart");

      if(mainCartItems.length == 0){
        window.location.reload();
      }

      for (let j=0; j<mainCartItems.length; j++){
        if(mainCartItems[j].getAttribute('cart-item-id') == globalDonationId ){
          if (quantityInput[j].getAttribute('value')){
            quantityInput[j].setAttribute('value', cartData.quantity);
          }
        }

        if(mainCartItems[j].getAttribute('cart-item-id') != globalDonationId){
          window.location.reload();
        }
      }

    }).catch(function(err) {
      //console.error(err);
    });
  }
}


document.addEventListener("DOMContentLoaded", function(){
  // -------------- Salvation Donation arrow expand Desktop
    showHideDonationDesc();

    function showHideDonationDesc() {

      let buttonArrow = document.getElementsByClassName("salv-desc-arrow-up");

      if(!buttonArrow){
        return;
      }

      let salvWrapper = document.getElementById("salv-wrapper");

      if(!salvWrapper){
        return;
      }

      salvWrapper.style.visibility = "visible";

      for (let i=0; i<buttonArrow.length; i++){
        buttonArrow[i].addEventListener('click', function(){
          showHideDonationDescTrigger();
        });
      }

      function showHideDonationDescTrigger() {
        let donationDesc = document.getElementsByClassName("product-desc-text-wrapper");

        for (let i=0; i<buttonArrow.length; i++){
          for (let j=0; j<donationDesc.length; j++){
            if (donationDesc[j].classList.contains('open')){
              donationDesc[j].classList.remove("open");
              buttonArrow[i].classList.remove("up");
            }
            else{
              donationDesc[j].classList.add("open");
              buttonArrow[i].classList.add("up");
            }
          }
        }
      }
    }
  // ---------- Salvation Donation arrow expand Desktop END


  // -------------- Salvation Donation arrow expand Mobile
    showHideDonationDescMobile();

    function showHideDonationDescMobile() {

      let buttonArrowMobile = document.getElementsByClassName("salv-desc-arrow-up-mobile");

      if(!buttonArrowMobile){
        return;
      }

      let salvWrapper = document.querySelector(".mini-donation-mobile-version");

      if(!salvWrapper){
        return;
      }

      salvWrapper.style.visibility = "visible";

      for (let i=0; i<buttonArrowMobile.length; i++){
        buttonArrowMobile[i].addEventListener('click', function(){
          showHideDonationDescTrigger();
        });
      }

      function showHideDonationDescTrigger() {
        let donationDesc = document.getElementsByClassName("product-desc-text-wrapper-mobile");

        for (let i=0; i<buttonArrowMobile.length; i++){
          for (let j=0; j<donationDesc.length; j++){
            if (donationDesc[j].classList.contains('open')){
              donationDesc[j].classList.remove("open");
              buttonArrowMobile[i].classList.remove("up");
            }
            else{
              donationDesc[j].classList.add("open");
              buttonArrowMobile[i].classList.add("up");
            }
          }
        }
      }
    }
  // ---------- Salvation Donation arrow expand Mobile END


  // -------- Compact content on mobile --------- //
    compactSalvoMobile();

    function compactSalvoMobile() {

      const compactCta = document.querySelector('.salv-compact.link-button');
      const compactContent = document.querySelector('#salv-wrapper .salv-container');

      if (!compactCta || !compactContent) {
        return;
      }

      compactCta.addEventListener('click', function(){
        toggleCompactDisplay();
      });

      function toggleCompactDisplay() {
        if (compactContent.classList.contains('compacted')) {
          compactContent.classList.remove('compacted');
        } else {
          compactContent.classList.add('compacted');
        }
      }
    }
  // -------- Compact content on mobile END --------- //

  function resetLinks() {
      const linksExceptAll = document.querySelectorAll('quick-filter-links .quick-filter-links__link');

      linksExceptAll.forEach(link => {
        if(link.classList.contains('selected')) {
          link.click();
        }
      });
  }

  function detachQuickFilterLinks() {
    const quickFilterLinks = document.querySelectorAll('quick-filter-links span');
    quickFilterLinks.forEach(quickFilterLink => {
      quickFilterLink.style.pointerEvents = 'none'
    });
  }

  function registerQuickFilters() {
    const quickFilterLinks = document.querySelectorAll('quick-filter-links span');

    quickFilterLinks.forEach(quickFilterLink => {
      quickFilterLink.addEventListener('click', () => {
        if (quickFilterLink.innerHTML == "ALL") {
          quickFilterLink.classList.add('selected');
          resetLinks();
          return;
        }

        if (quickFilterLink.classList.contains('selected')) {
          quickFilterLink.classList.remove('selected');
        } else {
          quickFilterLink.classList.add('selected');
          document.querySelector('.quick-filter-links__all').classList.remove('selected');
        }

        const selectedQuickFilterLinks = document.querySelectorAll('quick-filter-links span.selected');
        if (selectedQuickFilterLinks.length === 0) {
          document.querySelector('.quick-filter-links__all').classList.add('selected');
        }

        const filterToClick = quickFilterLink.getAttribute('data-filter-name');
        const elem = document.querySelector('.' + filterToClick + '[value="' + quickFilterLink.textContent + '"]');
        elem.click();

        detachQuickFilterLinks();
      });
    });
  }

  registerQuickFilters();
});

class tabbedTable extends HTMLElement {
  constructor() {
    super();

    const tabs = this.querySelectorAll('[role="tab"]');
    const tabList = this.querySelector('[role="tablist"]');
    tabs.forEach((tab) => {
      tab.addEventListener("click", this.changeTabs);
    });

    const viewSwitch = this.querySelectorAll('button.switch-view');
    viewSwitch.forEach((btn) => {
      btn.addEventListener("click", this.changeView);
    });

    let tabFocus = 0;

    tabList.addEventListener("keydown", (e) => {
      if (e.keyCode === 39 || e.keyCode === 37) {
        tabs[tabFocus].setAttribute("tabindex", -1);
        if (e.keyCode === 39) {
          tabFocus++;
          if (tabFocus >= tabs.length) {
            tabFocus = 0;
          }
        } else if (e.keyCode === 37) {
          tabFocus--;
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1;
          }
        }
        tabs[tabFocus].setAttribute("tabindex", 0);
        tabs[tabFocus].focus();
      }
    });
  }

  changeTabs(e) {
    e.target.closest('.tabs').querySelectorAll('[aria-selected="true"]').forEach((t) => t.setAttribute("aria-selected", false));
    e.target.setAttribute("aria-selected", true);

    e.target.closest('.tabs').querySelectorAll('[role="tabpanel"]').forEach((p) => p.setAttribute("hidden", true));
    e.target.closest('.tabs').querySelector(`#${e.target.getAttribute("aria-controls")}`).removeAttribute("hidden");

    if(e.target.getAttribute("aria-no-scroll") == "true") return;

    e.target.scrollIntoView({behavior: "smooth"});
  }

  changeView(e) {
    const viewBlocks = document.querySelectorAll('div.view-case');
    const viewSwitch = document.querySelectorAll('button.switch-view');

    viewSwitch.forEach((btn) => {
      btn.classList.remove('active');
    });
    e.target.classList.add('active');

    viewBlocks.forEach((blk) => {
      blk.style.display = 'none';
    });
    viewBlocks.forEach((blk) => {
      if (blk.classList.contains('view-case--' + e.target.getAttribute('data-view'))) {
        blk.style.display = 'block';
      }
    });
  }
}
customElements.define('tab-table', tabbedTable);



class filterSearchResults extends HTMLElement {
  constructor() {
    super();
    const filterBtns = this.querySelectorAll('.filter-by-btn');
    filterBtns.forEach((btn) => {
      btn.addEventListener("click", this.reloadWithFilter.bind(this));
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('type')) {
      const currentType = urlParams.get('type');
      this.querySelector(`[data-filterBy="${currentType}"]`)?.classList.add('active');
    } else {
      this.querySelector(`[data-filterBy="all"]`)?.classList.add('active');
    }
  }

  reloadWithFilter(e) {
    e.preventDefault();

    const urlParams = new URLSearchParams(window.location.search);
    const filterAtt = e.target.getAttribute('data-filterBy');
    let newUrl = '';
    let noChange = false;

    if (urlParams.has('type')) {
      const currentType = urlParams.get('type');
      if (currentType != filterAtt) {
        if (filterAtt == 'all') {
          newUrl = window.location.href.replace('&type=' + currentType, '');
        } else {
          newUrl = window.location.href.replace('&type=' + currentType, '&type=' + filterAtt);
        }
      } else {
        noChange = true;
      }
    } else {
      if (filterAtt != 'all') {
        newUrl = window.location.href + '&type=' + filterAtt;
      } else {
        noChange = true;
      }
    }

    if (!noChange) {
      window.location.href = newUrl;
    }
  }
}
customElements.define('search-results-filters', filterSearchResults);



class mobileQuickbuyModal extends HTMLElement {
  constructor() {
    super();
    this.variantLabels = this.querySelectorAll('.variant-selector-label');
    this.atcTrigger = this.querySelector('.mobile-quickbuy__atc');
    this.atcData = this.querySelector('form input[name="id"]');
    this.miniCart = document.getElementById('mini-cart');
    this.cartItems = document.querySelector('cart-items');

    this.variantLabels.forEach((btn) => {
      btn.addEventListener("click", this.varChange.bind(this));
    });
    this.atcTrigger.addEventListener("click", this.atcFunc.bind(this));

    // const urlParams = new URLSearchParams(window.location.search);
    // if (urlParams.has('type')) {
    //   const currentType = urlParams.get('type');
    //   this.querySelector(`[data-filterBy="${currentType}"]`)?.classList.add('active');
    // } else {
    //   this.querySelector(`[data-filterBy="all"]`)?.classList.add('active');
    // }
  }

  varChange(e) {
    const targetInput = e.target.querySelector('input');
    if (targetInput) {
      const newSize = targetInput.getAttribute('value');
      const newVariant = targetInput.getAttribute('data-variant-id');
      const newPrice = targetInput.getAttribute('data-price');
      const newWasPrice = targetInput.getAttribute('data-was-price');

      this.atcData.setAttribute('value', newVariant);
      this.querySelector('.mobile-quickbuy-size-name').innerHTML = newSize;
      this.querySelector('.mobile-quickbuy-details-info__price').innerHTML = newPrice;
      if (newWasPrice != '£0.00') {
        this.querySelector('.mobile-quickbuy-details-info__wasprice').innerHTML = newWasPrice;
        this.querySelector('.mobile-quickbuy-details-info__wasprice').style.display = 'inline-block';
      } else {
        this.querySelector('.mobile-quickbuy-details-info__wasprice').style.display = 'none';
      }
      this.querySelector('.mobile-quickbuy-size-name').innerHTML = newSize;
      this.variantLabels.forEach((btn) => {
        btn.classList.remove('checked');
      });
      e.target.classList.add('checked');
      targetInput.checked = true;
    }

    document.querySelectorAll('.swiper.product-carousel .swiper-wrapper').forEach((slider) => {
      slider.style.overflow = 'hidden';
      setTimeout(() => {
        slider.style.overflow = '';
      }, 10);
    });
  }

  atcFunc(e) {
    e.preventDefault();

    this.atcTrigger.disabled = true;

    let itemsArr = [];
    itemsArr.push({
      id: this.atcData.getAttribute('value'),
      quantity: 1
    });

    let body = JSON.stringify({
      items: itemsArr,
      sections: this.cartItems.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then(response => response.json())
    .then(parsedState => {
      this.miniCart?.open(true);
      this.cartItems?.renderContents(parsedState);
      return this.cartItems?.checkGifts();
    })
    .catch(error => {
      console.error(error);
    })
    .finally(() => {
      this.atcTrigger.disabled = false;
      document.getElementById('quick-buy-content').innerHTML = '';
      document.body.classList.remove('quickbuy-open');
      let cardWrapper = document.getElementsByClassName("card-wrapper");
      for (let i = 0; i < cardWrapper.length; i++) {
        cardWrapper[i].classList.remove('active');
        document.getElementById(`mini-cart`).classList.remove('upsell-open');
      }
      if (this.cartItems) {
        body = JSON.parse(body);
        body.sections = this.cartItems.getSectionsToRender().map(section => section.id);
        body.sections_url = window.location.pathname;
      }
    });
  }
}
customElements.define('mobile-quickbuy-modal', mobileQuickbuyModal);


class yotpoFit extends HTMLElement {
  constructor() {
    super();

    const yotpoKey = this.getAttribute('data-yotpo');
    this.removeAttribute('data-yotpo');
    const prodId = this.getAttribute('data-productId');

    if (!yotpoKey) {
      return;
    }

    const endpoint = `https://api-cdn.yotpo.com/v1/widget/${yotpoKey}/products/${prodId}/reviews.json`;

    fetch(endpoint, {
        headers: {
        'Content-Type': 'application/json'
      },
      method: 'GET'
    })
    .then((response) => response.json())
    .then((responseJson) => {
      const answers = responseJson.response.bottomline.custom_fields_bottomline;
      let response_fit = '';
      for (var i = 0; i < Object.keys(answers).length; i++) {
        if (answers[Object.keys(answers)[i]].title == 'Fit') {
          response_fit = answers[Object.keys(answers)[i]].average_score;
        }
      }
      this.updateDisplay(response_fit);
    });
  }

  updateDisplay(feedback) {
    console.log('feedback incoming... ');
    console.log(feedback);

    const sml_text = this.getAttribute('data-small-text');
    const true_text = this.getAttribute('data-true-text');
    const lrg_text = this.getAttribute('data-big-text');

    switch(feedback) {
      case 1:
        this.innerHTML = sml_text;
        this.closest('.sizing-details-block__size-reviews').style.display = '';
        break;
      case 2:
        this.innerHTML = true_text;
        this.closest('.sizing-details-block__size-reviews').style.display = '';
        break;
      case 3:
        this.innerHTML = lrg_text;
        this.closest('.sizing-details-block__size-reviews').style.display = '';
        break;
    }
  }
}
customElements.define('yotpo-fit', yotpoFit);


class deliveryCountdown extends HTMLElement {
  constructor() {
    super();

    this.cut_off = this.getAttribute('data-cutoff');
    this.show_seconds = this.getAttribute('data-seconds');
    this.pre_lead_array = [this.getAttribute('data-sun-lead-pre'), this.getAttribute('data-mon-lead-pre'), this.getAttribute('data-tue-lead-pre'), this.getAttribute('data-wed-lead-pre'), this.getAttribute('data-thu-lead-pre'), this.getAttribute('data-fri-lead-pre'), this.getAttribute('data-sat-lead-pre')];
    this.post_lead_array = [this.getAttribute('data-sun-lead-post'), this.getAttribute('data-mon-lead-post'), this.getAttribute('data-tue-lead-post'), this.getAttribute('data-wed-lead-post'), this.getAttribute('data-thu-lead-post'), this.getAttribute('data-fri-lead-post'), this.getAttribute('data-sat-lead-post')];
    this.day_name_array = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    this.month_name_array = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    this.checkStatus();

    if (this.show_seconds == 'true') {
      window.setInterval(() => {
        this.checkStatus();
      }, 1000);
    }
  }

  checkStatus() {
    const current_stamp = new Date();
    const cut_off_stamp = new Date(current_stamp.getFullYear(), current_stamp.getMonth(), current_stamp.getDate(), this.cut_off.substring(0,this.cut_off.search(':')), this.cut_off.substring(this.cut_off.search(':') + 1));
    const before_cut_off = cut_off_stamp > current_stamp;

    let tomorrow_date = new Date();
    tomorrow_date.setDate(tomorrow_date.getDate() + 1);
    let cut_off_compare = new Date(cut_off_stamp);

    let expected_date = new Date(current_stamp);
    let delivery_array = this.pre_lead_array;

    if (!before_cut_off) {
      cut_off_compare.setDate(cut_off_compare.getDate() + 1);
      delivery_array = this.post_lead_array;
    }

    this.time_left = cut_off_compare - current_stamp

    const hrs_left = Math.floor(this.time_left / 1000 / 60 / 60);
    const mins_left = Math.floor((this.time_left / 1000 / 60) % 60);
    const secs_left = Math.floor((this.time_left / 1000) % 60);

    expected_date.setDate(expected_date.getDate() + (delivery_array[expected_date.getDay()] * 1));

    let day_del = this.day_name_array[expected_date.getDay()];
    if (expected_date.getDate() == tomorrow_date.getDate()) {
      day_del = 'Tomorrow';
    }
    const date_del = expected_date.getDate();
    const mon_del = this.month_name_array[expected_date.getMonth()];

    this.updatePage(hrs_left, mins_left, secs_left, day_del, date_del, mon_del);
  }

  updatePage(hrs_left, mins_left, secs_left, day_del, date_del, mon_del) {
    const est_date_cntr = this.querySelector('.del-date');
    const time_left_cntr = this.querySelector('.time-left');

    est_date_cntr.innerHTML = day_del + ', ' + date_del + ' ' + mon_del;

    if (this.show_seconds == 'true') {
      time_left_cntr.innerHTML = hrs_left + (hrs_left > 1 ? ' hrs ' : ' hr ') + mins_left + (mins_left > 1 ? ' mins ' : ' min ') + secs_left + (secs_left > 1 ? ' secs' : ' sec');
    } else {
      time_left_cntr.innerHTML = hrs_left + (hrs_left > 1 ? ' hrs ' : ' hr ') + mins_left + (mins_left > 1 ? ' mins ' : ' min');
    }
  }
}
customElements.define('delivery-countdown', deliveryCountdown);


class heraTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = [];
    this.tabs = this.querySelectorAll('[role=tab]');
    this.tabsArr = Array.prototype.slice.call(this.tabs);
    this.tabpanels = [];
    this.firstTab = null;
    this.lastTab = null;

    this.expand_control_buttons = this.querySelectorAll('.expand-control button');

    this.expand_control_buttons.forEach((btn) => {
      btn.addEventListener("click", this.toggleMore.bind(this));
    });

    for (let i = 0; i < this.tabs.length; i += 1) {
      let tab = this.tabs[i];
      let tabpanel = this.querySelector('#' + tab.getAttribute('aria-controls'));
      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);
      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true;
    }
    for (let i = 0; i < this.tabs.length; i += 1) {
      let tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].classList.remove('is-hidden');
        if (setFocus) {
          tab.focus();
        }
        if (this.tabpanels[i].querySelector('.tabpanel-content').scrollHeight > 110) {
          this.tabpanels[i].classList.add('expandable');
        }
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add('is-hidden');
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    let index;
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabsArr.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    let index;
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabsArr.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  onKeydown(event) {
    let tgt = event.currentTarget;
    let flag = false;
    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;
      case 'ArrowRight':
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;
      case 'Home':
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;
      case 'End':
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;
      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }

  toggleMore(event) {
    if (event.target.classList.contains('readmore')) {
      event.target.closest('[role=tabpanel]').classList.add('expand');
    } else {
      event.target.closest('[role=tabpanel]').classList.remove('expand');
    }
  }

}
customElements.define('hera-tabs', heraTabs);
